import {
  Building2Icon,
  CalendarIcon,
  CreditCardIcon,
  HelpCircleIcon,
  ShieldIcon,
} from "lucide-react";

export const proFAQs = [
  {
    emoji: <HelpCircleIcon className="w-6 h-6 text-primary" />,
    question: "Je suis nul en tech, je fais comment ?",
    answer: "On a pensé à vous : notre interface est plus simple qu'une trayeuse à vache. Et si ça coince, Nadège (notre bulldog américaine) vous guide par téléphone.",
    value: "tech",
  },
  {
    emoji: <Building2Icon className="w-6 h-6 text-primary" />,
    question: "Je suis un petit établissement, est-ce que ça vaut le coup ?",
    answer: "Que vous ayez 2 ou 200 chambres, notre solution s'adapte. Et avec 0% de commission, même les plus petits y trouvent leur compte.",
    value: "size",
  },
  {
    emoji: <CalendarIcon className="w-6 h-6 text-primary" />,
    question: "Comment ça marche concrètement ?",
    answer: "Vous recevez un lien magique à partager. Vos clients réservent en 3 clics, vous recevez une notification, et hop ! Plus besoin de décrocher le téléphone toutes les 5 minutes.",
    value: "how",
  },
  {
    emoji: <CreditCardIcon className="w-6 h-6 text-primary" />,
    question: "Combien ça coûte ?",
    answer: "Un prix fixe, sans surprise. Et surtout : 0% de commission sur les réservations. On n'est pas là pour vous piquer votre marge.",
    value: "price",
  },
  {
    emoji: <ShieldIcon className="w-6 h-6 text-primary" />,
    question: "Et si ça ne me convient pas ?",
    answer: "Pas de souci ! On ne vous attache pas avec une corde de betteraves. Vous pouvez arrêter quand vous voulez.",
    value: "cancel",
  },
];

export const userFAQs = [
  {
    emoji: <HelpCircleIcon className="w-6 h-6 text-primary" />,
    question: "Comment ça marche ?",
    answer: "Simple comme bonjour ! Vous repérez un endroit qui vous plaît, vous cliquez, vous réservez. Plus besoin de faire 15 appels pour savoir s'il reste de la place.",
    value: "how-user",
  },
  {
    emoji: <CreditCardIcon className="w-6 h-6 text-primary" />,
    question: "Est-ce que je paie plus cher ?",
    answer: "Pas un centime de plus ! Les prix sont les mêmes qu'en direct. On n'est pas là pour vous faire les poches.",
    value: "price-user",
  },
  {
    emoji: <ShieldIcon className="w-6 h-6 text-primary" />,
    question: "Et si j'ai un problème ?",
    answer: "On est là ! Un souci ? Une question ? Notre équipe répond plus vite que l'éclair (enfin, presque).",
    value: "support-user",
  },
];